import TabView, { OnTabChangeEvent } from '@gym-atoms/TabView/TabView';

import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@gym-redux/store';
import {
  GymChainAccessCategoriesHeaderRoutes,
  GymChainAccessCategoriesHeaderTabNames
} from '../../../particles/types/GymChainAccessCategory';
import { MembershipAccessCategoryListTable } from '../../pages/GymChainsPage/GymChainMembershipAccessCategoryList';
import { BookingAccessCategoryListTable } from '../../pages/GymChainsPage/GymChainBookingAccessCategoryList';

const GymChainAccessCategoryHeader = ({
  currentGymChainId,
  currentTab
}: GymChainAccessCategoryHeaderProps) => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [activeTab, setActiveTab] = useState(GymChainAccessCategoriesHeaderRoutes[currentTab]);

  const userId = useAppSelector((state) => state.user.userId);
  const userRole = useAppSelector((state) => state.user.userRole);
  const userRoleId = useAppSelector((state) => state.user.roleId);

  const tabViewItems = [
    {
      header: t('GYM_CHAIN_ACCESS_CATEGORY_HEADER.MEMBERSHIPS'),
      content: <MembershipAccessCategoryListTable gymChainId={+currentGymChainId} />
    },
    {
      header: t('GYM_CHAIN_ACCESS_CATEGORY_HEADER.BOOKINGS'),
      content: <BookingAccessCategoryListTable gymChainId={+currentGymChainId} />
    }
  ];

  const routes = [`/gymChains/${currentGymChainId}/gymChainAccessCategories`];

  const onTabChangeHandler = (e: OnTabChangeEvent) => {
    setActiveTab(e.index);
    history.push(routes[e.index]);
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="tab-view-align-custom">
            <TabView
              headerClassName="dashboard-header-tabs"
              items={tabViewItems}
              activeTab={activeTab}
              onTabChange={onTabChangeHandler}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export interface GymChainAccessCategoryHeaderProps {
  currentGymChainId: number;
  currentTab: GymChainAccessCategoriesHeaderTabNames;
}
export default GymChainAccessCategoryHeader;
